var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ColumnEditModal",
    _vm._b(
      {
        attrs: {
          value: _vm.value,
          configName: _vm.configName,
          columnId: _vm.columnId,
          editMode: _vm.editMode,
        },
        on: {
          input: function ($event) {
            return _vm.$emit("input", $event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "edit-modal-additions",
            fn: function (props) {
              return [
                _c(
                  "v-layout",
                  { attrs: { "pa-4": "", wrap: "" } },
                  [
                    _c(
                      "v-input",
                      {
                        attrs: { messages: _vm.autoAssignCheckboxMessages },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prepend",
                              fn: function () {
                                return [
                                  _c("v-checkbox", {
                                    attrs: {
                                      "input-value":
                                        _vm.getAutoAssignMonitoringFeatureValue(
                                          props.columnConfiguration
                                        ),
                                      disabled:
                                        !props.editMode || !props.implemented,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        _vm.callSetColumnMetadata(
                                          _vm.autoAssignMetadataKey,
                                          !_vm.getAutoAssignMonitoringFeatureValue(
                                            props.columnConfiguration
                                          )
                                        )
                                      },
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm._v(
                          "\n        Automaticaly assign new site data source to a Monitoring Feature\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("h3", [
                      _vm._v(
                        " Create new Stations with the given Site Id during Import "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-radio-group",
                      {
                        attrs: {
                          column: "",
                          value: _vm.getShouldCreateNewStationValue(
                            props.columnConfiguration
                          ),
                        },
                        on: {
                          change: function ($event) {
                            _vm.callSetColumnMetadata(
                              _vm.shouldCreateNewStationKey,
                              !_vm.getShouldCreateNewStationValue(
                                props.columnConfiguration
                              )
                            )
                          },
                        },
                      },
                      [
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: {
                            label:
                              "Allow Stations to be created in Envirodata when a new Station does not exist during an import",
                            value: true,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: {
                            label:
                              "Do not allow Stations to be created and mark the import as unsuccessful when a new Station does not exist during an import",
                            value: false,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h3", [
                      _vm._v(" Delete empty Stations during rollback "),
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-radio-group",
                      {
                        attrs: {
                          column: "",
                          value: _vm.getShouldDeleteDuringRollbackValue(
                            props.columnConfiguration
                          ),
                        },
                        on: {
                          change: function ($event) {
                            _vm.callSetColumnMetadata(
                              _vm.shouldDeleteDuringRollbackKey,
                              !_vm.getShouldDeleteDuringRollbackValue(
                                props.columnConfiguration
                              )
                            )
                          },
                        },
                      },
                      [
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: {
                            label:
                              "Delete Stations that have no data associated with them during a rollback",
                            value: true,
                          },
                        }),
                        _vm._v(" "),
                        _c("v-radio", {
                          staticClass: "radio-opts",
                          attrs: {
                            label:
                              "Do not delete Stations and mark the rollback as unsuccessful when attempting to delete a Station",
                            value: false,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      },
      "ColumnEditModal",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }